/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./form-panel.vue?vue&type=template&id=88b254b2&scoped=true&"
import script from "./form-panel.vue?vue&type=script&lang=ts&"
export * from "./form-panel.vue?vue&type=script&lang=ts&"
import style0 from "./form-panel.vue?vue&type=style&index=0&id=88b254b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b254b2",
  null
  
)

export default component.exports